import { api } from "@/api/api";
import type { CampaignRead, CampaignWrite } from "@/types/api/types";
import { paramsReducer } from "@/api/utils";

export const CampaignApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCampaigns: builder.query<CampaignRead, Record<string, any>>({
      query: (params) => paramsReducer("campaigns", params),
      providesTags: ["Campaigns"],
    }),

    getCampaign: builder.query<CampaignRead, string>({
      query: (uuid) => `campaigns/${uuid}`,
      providesTags: ["Campaigns"],
    }),

    addCampaign: builder.mutation<CampaignRead, CampaignWrite>({
      query: (body) => ({
        method: "POST",
        url: "campaigns",
        body,
      }),
      invalidatesTags: ["Campaigns"],
    }),

    updateCampaign: builder.mutation<
      CampaignRead,
      { uuid: string } & CampaignWrite
    >({
      query: ({ uuid, ...body }) => ({
        method: "PUT",
        url: `campaigns/${uuid}`,
        body,
      }),
      invalidatesTags: ["Campaigns"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCampaignsQuery,
  useGetCampaignQuery,
  useAddCampaignMutation,
  useUpdateCampaignMutation,
} = CampaignApi;
